export default __webpack_public_path__ + "static/media/bank1.aff8d41c.png";